"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFeatureFlagApi = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const MAX_RETRIES = 3;
/**
 * Retries a failed flag request with RTK Query's exponential backoff (about 3 seconds in all),
 * so a brief outage does not hide a flag that is on. A 4xx answer is final: retrying cannot fix it.
 */
const withRetry = (baseQuery) => (0, react_1.retry)(async (args, api, extraOptions) => {
    var _a;
    const result = await baseQuery(args, api, extraOptions);
    const status = (_a = result.error) === null || _a === void 0 ? void 0 : _a.status;
    if (typeof status === 'number' && status >= 400 && status < 500)
        react_1.retry.fail(result.error);
    return result;
}, { maxRetries: MAX_RETRIES });
/**
 * Feature flag API factory — see createTicketApi.ts for the shared-package baseQuery-injection
 * pattern. Flags are cached for the session (no polling); refetch on app/window focus and
 * reconnect keeps them current.
 */
const createFeatureFlagApi = (baseQuery) => (0, react_1.createApi)({
    reducerPath: 'featureFlagApi',
    baseQuery: withRetry(baseQuery),
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: (builder) => ({
        getFeatureFlags: builder.query({
            query: () => 'FeatureFlags',
        }),
    }),
});
exports.createFeatureFlagApi = createFeatureFlagApi;
